module.exports = __webpack_public_path__ + "img/1.af483752.webp";